// Actual payload for RSet operations, and their format validators.
import { json } from "@hyper-hyper-space/hhs3_json";
import { MAX_TYPE_LENGTH, createPayloadTypeFormat } from "@hyper-hyper-space/hhs3_mvt";
import { MAX_KEY_ID_LENGTH, MAX_SIGNATURE_LENGTH } from "../../authorship.js";
export const MAX_SEED_LENGTH = 1024;
export const MAX_HASH_LENGTH = 128;
export const MAX_ELEMENTS_TYPE_ID_LENGTH = 256;
export const MAX_INITIAL_ELEMENTS = 1024;
export const MAX_HASH_ALGORITHM_LENGTH = 256;
export const MAX_CAP_NAME = 256;
export const MAX_REF_ADVANCE_CAPS = 64;
export const capRequirementsFormat = {
    add: [json.Type.Option, [json.Type.BoundedString, MAX_CAP_NAME]],
    delete: [json.Type.Option, [json.Type.BoundedString, MAX_CAP_NAME]],
    refAdvance: [json.Type.Option, [json.Type.BoundedArray, [json.Type.BoundedString, MAX_CAP_NAME], MAX_REF_ADVANCE_CAPS]],
    refAdvanceCreators: [json.Type.Option, json.Type.Boolean],
};
export const RSET_TYPE_ID = 'hhs/set_v1';
export const createSetFormat = {
    action: [json.Type.Constant, 'create'],
    type: createPayloadTypeFormat(RSET_TYPE_ID),
    seed: [json.Type.BoundedString, MAX_SEED_LENGTH],
    contentType: [json.Type.Option, [json.Type.BoundedString, MAX_TYPE_LENGTH]],
    initialElements: [json.Type.BoundedArray, json.Type.String, MAX_INITIAL_ELEMENTS],
    acceptRedundantAdd: [json.Type.Option, json.Type.Boolean],
    acceptRedundantDelete: json.Type.Boolean,
    acceptUpdateForDeleted: [json.Type.Option, json.Type.Boolean],
    supportBarrierAdd: [json.Type.Option, json.Type.Boolean],
    supportBarrierDelete: [json.Type.Option, json.Type.Boolean],
    hashAlgorithm: [json.Type.Option, [json.Type.BoundedString, MAX_HASH_ALGORITHM_LENGTH]],
    parent: [json.Type.Option, [json.Type.BoundedString, MAX_HASH_LENGTH]],
    capabilityRef: [json.Type.Option, [json.Type.BoundedString, MAX_HASH_LENGTH]],
    capRequirements: [json.Type.Option, capRequirementsFormat],
};
export const addElmtFormat = {
    action: [json.Type.Constant, 'add'],
    element: json.Type.Something,
    barrier: [json.Type.Option, json.Type.Boolean],
};
export const deleteElmtFormat = {
    action: [json.Type.Constant, 'delete'],
    elementHash: [json.Type.BoundedString, MAX_HASH_LENGTH],
    barrier: [json.Type.Option, json.Type.Boolean],
};
export const updateElmtFormat = {
    action: [json.Type.Constant, 'update'],
    elementHash: [json.Type.BoundedString, MAX_HASH_LENGTH],
    updatePayload: json.Type.Something,
};
// Authored variants for permissioned sets:
export const addElmtAuthoredFormat = {
    action: [json.Type.Constant, 'add'],
    element: json.Type.Something,
    barrier: [json.Type.Option, json.Type.Boolean],
    author: [json.Type.BoundedString, MAX_KEY_ID_LENGTH],
    signature: [json.Type.BoundedString, MAX_SIGNATURE_LENGTH],
};
export const deleteElmtAuthoredFormat = {
    action: [json.Type.Constant, 'delete'],
    elementHash: [json.Type.BoundedString, MAX_HASH_LENGTH],
    barrier: [json.Type.Option, json.Type.Boolean],
    author: [json.Type.BoundedString, MAX_KEY_ID_LENGTH],
    signature: [json.Type.BoundedString, MAX_SIGNATURE_LENGTH],
};
